import { toAbsoluteUrl } from "../utils/utils";

export const initLayoutConfig = {
  //demo: "demo1",
  demo:'onpoint-app',
  // == Base Layout
  self: {
    layout: "fluid", //"fluid", "blank"
    // body: { "background-image": toAbsoluteUrl("/media/misc/bg-1.jpg") },
    logo: {
      dark: toAbsoluteUrl("/media/logos/logo-light.png"),
      light: toAbsoluteUrl("/media/logos/logo-dark.png"),
      brand: toAbsoluteUrl("/media/logos/logo-light.png"),
      green: toAbsoluteUrl("/media/logos/logo-light.png")
    }
  },
  // == Portlet Plugin
  // portlet: {
  //   sticky: {
  //     offset: 50
  //   }
  // },
  // == Page Splash Screen loading
  loader: {
    enabled: false,
    type: "spinner-logo",
    logo: toAbsoluteUrl("/media/logos/logo-mini-md.png"),
    message: "Please wait..."
  },
  // == Colors for javascript
  colors: {
    state: {
      brand: "#eb680e",
      dark: "#282a3c",
      light: "#ffffff",
      primary: "#5867dd",
      success: "#34bfa3",
      info: "#36a3f7",
      warning: "#ffb822",
      danger: "#fd3995"
    },
    base: {
      label: ["#c5cbe3", "#a1a8c3", "#3d4465", "#3e4466"],
      shape: ["#f0f3ff", "#d9dffa", "#afb4d4", "#646c9a"]
    }
  },
  // page toolbar
  toolbar: {
    display: false
  },
  header: {
    self: {
      width: "fluid", // fixed|fluid
      skin: "dark",
      fixed: {
        desktop: true,
        mobile: true
      }
    },
    menu: {
      self: {
        display: true,
        layout: "tab",
        'root-arrow': true,
        'icon-style': "duotone"
      },
      desktop: {
        arrow: true,
        toggle: "click",
        submenu: {
          skin: "dark",
          arrow: true
        }
      },
      mobile: {
        submenu: {
          skin: "dark",
          accordion: true
        }
      }
    }
  },
  subheader: {
    display: false,
    displayDesc: true,
    displayDaterangepicker: true,
    layout: "subheader-v1",
    fixed: true,
    width: 'fluid', // fixed|fluid,
    clear: false,
    style: 'solid'
  },
  content: {
    width: "fluid"
  },
  brand: {
    self: {
      skin: "dark"
    }
  },
  aside: {
    self: {
      skin: "dark",
      display: true,
      fixed: true,
      minimize: {
        toggle: true,
        default: true
      }
    },
    footer: {
      self: {
        display: false
      }
    },
    menu: {
      dropdown: "false",
      scroll: false,
      "icon-style": "duotone",
      submenu: {
        accordion: true,
        dropdown: {
          arrow: true,
          "hover-timeout": 100
        }
      }
    }
  },
  footer: {
    self: {
      width: 'fluid',
      fixed: true
    }
  }
};

let LayoutConfig = JSON.parse(JSON.stringify(initLayoutConfig)); // deep object copy
export default LayoutConfig;